module.exports = __webpack_public_path__ + "img/suo.c3d6a31c.png";